import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../../../styles";
export const StyledInformationIcon = styled.span `
	color: ${Mi.slatIconColor};
	margin-left: ${Mi.spacer06};
`;
//# sourceMappingURL=InformationIcon.style.js.map